// Lodash
import _property from 'lodash/property';

var name = _property('name');

var displayName = _property('displayName');

var mediaType = _property('mediaType');

var type = _property('type');

var draftType = _property('draftType');

var READER = {
  name: name,
  displayName: displayName,
  mediaType: mediaType,
  type: type,
  draftType: draftType
};
export default READER;